/* eslint-disable max-len */
import React from 'react';

const Copying: React.FC<object> = () => {

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6222_116373)">
                <path
                    d="M2 4.5H10C10.8284 4.5 11.5 5.17157 11.5 6V14C11.5 14.8284 10.8284 15.5 10 15.5H2C1.17157 15.5 0.5 14.8284 0.5 14V6C0.5 5.17157 1.17157 4.5 2 4.5Z"
                    stroke="currentColor"
                />
                <path
                    d="M13.3346 11.3337V11.3337C14.4392 11.3337 15.3346 10.4382 15.3346 9.33366V2.66699C15.3346 1.56242 14.4392 0.666992 13.3346 0.666992H6.66797C5.5634 0.666992 4.66797 1.56242 4.66797 2.66699V2.66699"
                    stroke="currentColor"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_6222_116373">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>

    );
};

export default Copying;